import Errors from "./errors";
import _ from "lodash";
import ContractsService from "@/services/ContractsService";
import moment from "moment";
import store from "@/store";

class Form {
  /**
   * Create a new Form instance.
   */
  constructor(service, data) {
    this.originalData = data;
    this.service = service;
    this.loading = false;
    this.data = {};
    this.preSubmitData = {};
    this.search = { field: "site", term: "", date: "" };
    this.siteSearch = { field: "site", term: "", service: null };
    this.formId = "#edit";
    this.modal = {
      title: null,
    };
    this.showPreviousPager = false;
    this.showNextPager = false;
    this.previousPageNumber = 0;
    this.nextPageNumber = 0;
    this.updateStore = false;
    this.successCallback = data.successCallback || (() => null);

    for (let field in data) {
      this.data[field] = data[field];
    }

    this.data.id = data.id || null;
    this.list = {};

    this.errors = new Errors();
  }

  /**
   * get the list of items
   */
  getList(page = 1) {
    this.isLoading();
    this.service
      .getList(page)
      .then((data) => {
        this.list = data.data;
        this.links = data.links;
        this.processPagination();
        this.notLoading();
      })
      .catch((errorMessage) => {
        this.onFail({}, errorMessage);
      });
  }

  onSearch(page = 1) {
    this.isLoading();
    let search = {
      field: this.search.field,
    };
    if (this.search.field === "date") {
      search.term = moment(this.search.date).format("YYYY-MM-DD");
    } else {
      search.term = this.search.term;
    }
    this.service
      .search(search, page)
      .then((data) => {
        this.list = data.data;
        this.links = data.links;
        this.notLoading();
        this.processPagination();
      })
      .catch((errorMessage) => {
        this.onFail({}, errorMessage);
      });
  }

  clearSearch() {
    this.isLoading();
    this.search.term = null;
    this.search.date = null;
    this.getList();
  }

  onSiteSearch(fieldName) {
    store.dispatch("setSiteSearchLoading", true);

    let search = {
      field: this.siteSearch.field,
      term: this.siteSearch.term,
    };

    let service = this.siteSearch.service
      ? this.siteSearch.service
      : this.service;

    service
      .siteSearch(search)
      .then((data) => {
        if (data.data) {
          store.dispatch("setSiteSearchResults", data.data);
          if (data.data.length) {
            this.data[fieldName] = data.data[0].id;
          }
        }
        this.processPagination();
        store.dispatch("setSiteSearchLoading", false);
      })
      .catch((errorMessage) => {
        store.dispatch("setSiteSearchClear");

        this.onFail({}, errorMessage);
      });
  }

  processPagination() {
    if (_.has(this.links, "prev") && this.links.prev) {
      this.showPreviousPager = true;
      this.previousPageNumber = this.getPageNumber(this.links.prev);
    } else {
      this.showPreviousPager = false;
      this.previousPageNumber = 1;
    }

    if (_.has(this.links, "next") && this.links.next) {
      this.showNextPager = true;
      this.nextPageNumber = this.getPageNumber(this.links.next);
    } else {
      this.showNextPager = false;
      this.nextPageNumber = 1;
    }
  }

  getPageNumber(query) {
    let number = 1;
    if (query) {
      let matches = query.match(/page%5Bnumber%5D=(\d+)\&/);
      number = matches[1];
    }

    return number;
  }

  /**
   * get the details for an item
   */
  getDetails(id) {
    if (this.service.hasOwnProperty("getDetails")) {
      return this.service
        .getDetails(id)
        .then((data) => {
          this.data = data;
          return Promise.resolve();
        })
        .catch((errorMessage) => {
          this.onFail({}, errorMessage);
        });
    }
  }

  /**
   * show the modal edit
   *
   * @param id
   * @param list
   * @param title
   * @param formId
   */
  showEdit({
    id = null,
    list = false,
    title = null,
    formId = "#edit",
    data = {},
  }) {
    this.formId = formId;
    if (id) {
      this.modal.title = title || "Edit Data";

      if (!list) {
        let item = _.find(this.list, ["id", id]);

        for (let property in this.originalData) {
          if (_.has(item, "attributes")) {
            this.data[property] = item.attributes[property];
          }
        }
        this.data.id = id;

        this.errors.clear();
      }
    } else {
      this.modal.title = title || "Add Data";

      this.reset();
    }
    if (data) {
      this.data = {
        ...this.data,
        ...data,
      };
    }

    $(formId)
      .modal({ backdrop: "static" })
      .modal("show");
  }

  hideEdit() {
    $(this.formId).modal("hide");
  }

  /**
   * post/patch an object
   */
  onSubmit({ updateStore = false, updateList = true, comment = false } = {}) {
    this.updateStore = updateStore;
    this.isLoading();
    this.preSubmitData = {
      ...this.data,
    };
    if (this.data.id && this.data.id !== "null") {
      // update
      return this.service
        .update(this.cleanData(this.data))
        .then((data) => {
          let reset = false;
          // list update
          let index = _.indexOf(this.list, _.find(this.list, ["id", data.id]));
          if (index > -1) {
            this.list.splice(index, 1, data);
            reset = true;
          }
          this.data.id = data.id;
          this.getDetails(this.data.id);

          if (comment) {
            window.bus.$emit("comment-updated");
          } else {
            window.bus.$emit("item-updated", data.id);
          }

          this.onSuccess("Successfully updated.", reset);
        })
        .catch((errors) => {
          this.onFail(errors, "There is a problem with the form.");
        });
    } else {
      // create
      return this.service
        .create(this.cleanData(this.data))
        .then((data) => {
          if (updateList) {
            // list prepend
            this.list.unshift(data);
          }

          if (comment) {
            window.bus.$emit("comment-created");
          } else {
            // allow component to deal with item-created event
            window.bus.$emit("item-created", data.id);
          }

          this.onSuccess("Successfully created.");
        })
        .catch((errors) => {
          this.onFail(errors, "There is a problem with the form.");
        });
    }
  }

  cleanData(data) {
    // remove empty contracts
    data.contracts = _.uniq(_.without(data.contracts, ""));

    return data;
  }

  /**
   * delete an object
   *
   * @param id
   */
  destroy(id, { comment = false } = {}) {
    let answer = confirm("Are you sure you want to delete this item?");
    if (answer) {
      this.isLoading();
      this.service
        .delete(id)
        .then((data) => {
          if (!comment) {
            // list update
            let index = _.indexOf(
              this.list,
              _.find(this.list, ["id", data.id])
            );
            try {
              this.list.splice(index, 1);
            } catch (e) {
              console.log(`unable to delete ${id} from list`);
            }
          }

          if (comment) {
            window.bus.$emit("comment-deleted");
          } else {
            window.bus.$emit("item-deleted");
          }

          this.onSuccess("Successfully deleted.");
        })
        .catch((errorMessage) => {
          this.onFail({}, errorMessage);
        });
    }
  }

  getContracts() {
    return ContractsService.getList().then((data) => {
      return data;
    });
  }

  addContract() {
    if (typeof this.data.contracts !== "object") {
      this.data.contracts = [];
    }

    this.data.contracts.push("");
  }

  removeContract(index) {
    this.data.contracts.splice(index, 1);
  }

  working() {
    return this.loading;
  }

  isLoading() {
    this.loading = true;
  }

  notLoading() {
    this.loading = false;
  }

  /**
   * Reset the form fields.
   */
  reset() {
    for (let field in this.data) {
      if (typeof this.data[field] !== "boolean") {
        this.data[field] = this.originalData[field];
      }
    }
    this.data.id = null;

    this.errors.clear();
  }

  /**
   * show success and clean up
   *
   * @param message
   */
  onSuccess(message, reset = true) {
    toastr.success(message);
    $(this.formId).modal("hide");
    if (reset) {
      this.reset();
    }
    if (this.updateStore) {
      this.service.getList().then((data) => {
        store.dispatch(
          `set${this.service.name.replace("Service", "")}`,
          data.data
        );
      });
    }
    this.notLoading();
    const { successCallback, preSubmitData } = this;
    setTimeout(() => successCallback(preSubmitData), 1000);
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors, message) {
    toastr.error(message);
    this.errors.record(errors);
    // force data to update, so that errors show
    let first = Object.keys(this.data)[0];
    this.data[first] = this.data[first] + " ";
    this.data[first] = this.data[first].trim();
    this.notLoading();
  }

  previousPage() {
    if (this.search.term) {
      this.onSearch(this.previousPageNumber);
    } else {
      this.getList(this.previousPageNumber);
    }
  }

  nextPage() {
    if (this.search.term) {
      this.onSearch(this.nextPageNumber);
    } else {
      this.getList(this.nextPageNumber);
    }
  }
}

export default Form;
